import React from "react";
import { Badge } from "@/components/ui/badge";
const partners = [{
  id: 1,
  name: "Aman Resorts",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_aman.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_aman.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_aman.png-wvc-sizes"
}, {
  id: 2,
  name: "Belmond",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_belmond.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_belmond.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_belmond.png-wvc-sizes"
}, {
  id: 3,
  name: "Four Seasons",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_fourseasons.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_fourseasons.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_fourseasons.png-wvc-sizes"
}, {
  id: 4,
  name: "Rosewood Hotels",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_rosewood.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_rosewood.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_rosewood.png-wvc-sizes"
}, {
  id: 5,
  name: "Six Senses",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_sixsenses.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_sixsenses.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/partner_sixsenses.png-wvc-sizes"
}];
export default function OurTrustedPartners() {
  return <section data-section-id="257835" id="our-trusted-partners" className="bg-background text-foreground py-12 md:py-16 relative w-full border-t border-border/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="flex justify-end mb-10 md:mb-12">
          <Badge variant="default" className="bg-secondary text-secondary-foreground rounded-md px-5 py-2 text-xs sm:text-sm md:text-base font-bold tracking-widest uppercase shadow-sm font-default border border-primary/20">
            IATA GOlite Certified
          </Badge>
        </div>

        {}
        <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-10 md:gap-14 lg:gap-20">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex items-center justify-center w-24 sm:w-32 md:w-40 lg:w-48 transition-all duration-700 hover:opacity-100 opacity-60 grayscale hover:grayscale-0">
              <img src={partner.src} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={`${partner.name} logo`} className="w-full h-auto object-contain max-h-12 sm:max-h-16 md:max-h-20" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}